import store from "@/store";
import colors from "vuetify/lib/util/colors";
import vuetify from "../../plugins/vuetify";

const state = {
  name: "caterpoint",

  dark: {
    primary: "#1984c3",
    accent: "#FF4081",
    secondary: colors.blue.darken2,
    success: "#4CAF50",
    info: "#2196F3",
    warning: "#FB8C00",
    error: "#FF5252",
    // anchor: "#DADADA",

    background: "#171717",
    background_alt: "#171717",
    background_off: "#1d1d1d",
    footerColor: "#171717",
  },

  light: {
    primary: colors.blue.darken2,
    accent: "#e91e63",
    secondary: colors.blue.darken2,
    success: "#4CAF50",
    info: "#2196F3",
    warning: "#FB8C00",
    error: "#FF5252",
    // anchor: "#565656",

    background: colors.shades.white,
    background_alt: colors.shades.white,
    background_off: "#F4F4F5",
    footerColor: colors.shades.white,
  },
};

const getters = {
  retrieveCaterpointThemeDetails: (state) => {
    return state;
  },
};

const actions = {
  setCaterpointTheme({ commit }) {
    console.log(" -- Set Caterpoint Theme Called");
    const response = commit("setCaterpointTheme");
    return response;
  },
};

const mutations = {
  setCaterpointTheme: (state) => {
    state.light.primary = store.getters.retrieveAllConfigs.css_primary_bg;
    vuetify.framework.theme.themes.dark.primary = "#1984c3";

    state.light.menu_color =
      store.getters.retrieveAllConfigs.css_menu_button_text;
    vuetify.framework.theme.themes.dark.menu_color = colors.grey.lighten5;

    state.light.menu_icon =
      store.getters.retrieveAllConfigs.css_menu_button_icon;
    vuetify.framework.theme.themes.dark.menu_icon = colors.grey.lighten3;

    return;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
